import Colors from './Colors'

const breakpoints = {
  mobile: '768px',
  tablet: '992px',
  giant: '1200px'
}

const grid = {
  tablet: '720px',
  desktop: '960px',
  mobile: '332px', // in case of mobile it takes 20px as padding,
  giant: '1140px'
}

const borders = {
  default: `1px solid ${Colors.lightGrey}`,
  defaultOrange: `1px solid ${Colors.primary}`,
  defaultRadius: '4px',
  headerBorder: `solid 1px ${Colors.lightGrey}`,
  inputBorder: `solid 1px ${Colors.lightGrey}`,
  orangeBorder: `solid 1px ${Colors.primary}`,
  boldBoder: `solid 3px ${Colors.lightGrey}`,
  defaultBorder: `solid 2px ${Colors.lightGrey}`,
  searchbar: 'solid 1px #e6e6e6'
}

const components = {
  sidebar: '200px',
  navbarDefault: '64px',
  profilePhoto: '142px',
  landingFooter: '64px',
  searchbar: '60px',
  adminNavbar: '60',
  adminScreensMinWidth: '1024px',
  cardContainerSpacing: '25px',
  adminAvatarSize: 38,
  inputFormHeight: '30px',
  customThemeSpacing: '32px',
  navbarMobileLogoMargins: '94px',
  themeMobileMargins: '20px',
  adminContent: 'calc(100vh - 60px)',
  adminListRow: '150px',
  adminLogoSize: '130px',
  landingLogoSize: '170px',
  mobileSearchBarSize: '80px',
  listSize: '180px',
  mobileMenu: '225px',
  modalHeight: '470px',
  modalWidth: '515px',
  modalContainer: '400px'
}

const shadows = {
  default: '0 1px 5px rgba(0, 0, 0, 0.1)',
  defaultShadow: '0 4px 8px 0 rgba(81, 96, 115, 0.18)',
  cardShadow: '0 4px 5px 0 rgba(81, 96, 115, 0.12);',
  cardContainerShadow: '0 2px 4px 0 #b6b6b6',
  adminNavbarShadow: '0 1px 3px 0 #b6b6b6',
  rowShadow: '0 2px 4px 0 rgba(44, 48, 48, 0.2)'
}

const overlay = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  backdropFilter: 'blur(2px)',
  backgroundColor: Colors.overlay
}

const margins = {
  base: '20px',
  tiny: '5px',
  small: '10px',
  medium: '15px',
  large: '25px',
  largeLarger: '27px',
  larger: '30px',
  big: '50px'
}

export default {
  borders,
  shadows,
  overlay,
  margins,
  components,
  breakpoints,
  grid
}



// WEBPACK FOOTER //
// ./src/Themes/Metrics.js